import { post } from 'srs-middleware';

// Usage Stat handlers

type ActionNames = 'PageLoaded' | 'DocumentOpened' | 'SearchTermEntered' | "FacetAdded" | "HierarchicalFacetAdded" | 'TreeMapZoomed' | "TimelineFilterAdded";
type PayloadFunction = () => string;
type UsagePayload = string | PayloadFunction | null;

let isUsageEndpointAvailable = false;

/**
 * Send a usage stat message to the server, if the feature is available. Pass a function as the payload to get error
 * handling for that function.
 */
export function sendUsageAction(actionName: ActionNames, payload: UsagePayload) {
	if (isUsageEndpointAvailable) {
		(async () => {
			try {
				await post('/SRS/Application/SlyKit/Usage', {
					action: actionName,
					payload: typeof payload === 'function' ? payload() : payload,
				});
			} catch (e) {
				// We want to fail gracefully. We can safely ignore an error for this
			}
		})();
	}
}

let hasPageLoadHappened = false;

/**
 * Send the page load event and also detects if the Usage endpoint is available
 */
export function sendPageLoad() {
	if (!hasPageLoadHappened) {
		hasPageLoadHappened = true;
		(async () => {
			try {
				const name: ActionNames = 'PageLoaded';
				await post('/SRS/Application/SlyKit/Usage', {
					action: name,
				});
				isUsageEndpointAvailable = true;
			} catch (e) {
				// This is redundant but we'll just have it here in case
				isUsageEndpointAvailable = false;
			}
		})();
	}
}
